import type { ListBuilderList } from '../../../types';
import { createClientColumnsNoLifecycle } from '../columns';
import {
	ACTIVITY_LIST_ACTIVE_FILTERS,
	SALESPEOPLE_FILTER_RULES_SELF_DEFAULT,
	createClientKanbanConfig,
} from '../shared';

/**
 * At Risk list configuration
 * Existing customers with declining business trends, prioritized by severity
 */
export const atRiskList: ListBuilderList = {
	id: 'at-risk-list',
	cacheTTL: 600000,
	name: 'At Risk',
	type: 'default',
	active: true,
	bulkActionTemplate: 'clients',
	columns: createClientColumnsNoLifecycle(),
	description:
		'Existing customers with declining business trends, prioritized by severity',
	defaultSortId: 'revenue-trend-90-days-asc',
	requiredFields: [
		'client._id',
		'client.address1',
		'client.averageInvoiceRevenue',
		'client.businessType',
		'client.city',
		'client.companyNames',
		'client.email',
		'client.externalId',
		'client.externalId2',
		'client.fax',
		'client.forecastedReorderDate',
		'client.googlePlaceId',
		'client.lastContactDate',
		'client.latitude',
		'client.leadOrCustomer',
		'client.longitude',
		'client.minimumTrendDiff',
		'client.name',
		'client.nextActivityDate',
		'client.phone',
		'client.salesStatus',
		'client.state',
		'client.zip',
	],
	filters: {
		activeFilters: ACTIVITY_LIST_ACTIVE_FILTERS,
	},
	sortOrder: 5,
	filterRules: {
		...SALESPEOPLE_FILTER_RULES_SELF_DEFAULT,
		callStatus: {
			defaultValue: [
				{
					id: 'Callable',
					label: 'Callable',
				},
			],
		},
		leadOrCustomer: {
			defaultValue: [
				{
					id: 'Customer',
					label: 'Customer',
				},
			],
		},
		specialFilters: {
			defaultValue: [
				{
					id: 'at_risk',
					label: 'At Risk',
				},
			],
		},
	},
	kanbanConfig: createClientKanbanConfig(),
};
